document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.product');
  if (!container) return;

  const gallery = container.querySelector('.product-gallery');
  const info = container.querySelector('.product-info');
  
  if (!gallery || !info) return;

  let stickyElement = null;
  let lastScrollY = window.scrollY;
  let currentTop = 0;
  let initialTop = 20;

  function getHeaderHeight() {
    const stickyArea = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    return stickyArea + 20;
  }

  function evaluateSticky() {
    if (window.innerWidth < 1000) {
      if (stickyElement) {
        stickyElement.classList.remove('dynamic-sticky');
        stickyElement.style.position = '';
        stickyElement.style.top = '';
        stickyElement = null;
      }
      return;
    }

    // Reset styles to measure natural heights
    gallery.style.position = 'static';
    gallery.style.top = '';
    info.style.position = 'static';
    gallery.classList.remove('dynamic-sticky');
    info.classList.remove('dynamic-sticky');

    // Small delay to let browser reflow
    setTimeout(() => {
      const gHeight = gallery.getBoundingClientRect().height;
      const iHeight = info.getBoundingClientRect().height;

      let newSticky = null;
      if (gHeight < iHeight) {
        newSticky = gallery;
      } else if (iHeight < gHeight) {
        newSticky = info;
      }
      
      stickyElement = newSticky;
      
      if (stickyElement) {
        stickyElement.classList.add('dynamic-sticky');
        stickyElement.style.position = ''; // Remove inline static
        
        initialTop = getHeaderHeight();
        currentTop = initialTop;
      }
    }, 50);
  }

  function handleScroll() {
    if (!stickyElement || window.innerWidth < 1000) return;
    
    if (stickyElement.tagName.toLowerCase() === 'safe-sticky') {
      // Let theme handle safe-sticky natively
      return;
    }
    
    const viewportHeight = window.innerHeight;
    const elHeight = stickyElement.clientHeight;
    
    if (elHeight <= (viewportHeight - initialTop)) {
      stickyElement.style.top = `${initialTop}px`;
      lastScrollY = window.scrollY;
      return;
    }

    const minTop = elHeight - viewportHeight + 20;

    if (window.scrollY < lastScrollY) {
      currentTop += (lastScrollY - window.scrollY);
    } else {
      currentTop -= (window.scrollY - lastScrollY);
    }
    
    currentTop = Math.min(Math.max(currentTop, -minTop), initialTop);
    lastScrollY = window.scrollY;
    
    stickyElement.style.top = `${Math.round(currentTop)}px`;
  }

  // Use ResizeObserver for accurate height changes
  const resizeObserver = new ResizeObserver(() => {
    evaluateSticky();
  });
  resizeObserver.observe(gallery);
  resizeObserver.observe(info);

  window.addEventListener('scroll', handleScroll, {passive: true});
  window.addEventListener('resize', evaluateSticky);
});
